import _ from "underscore";

export default function addPropertiesIfDefined<Type extends Record<string, any>>(instance: Type, properties: Partial<Type>) {
  _.forEach(properties, (value, property) => {
    if (value != null) {
      instance[property] = value;
    }
  });
}
